import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css'],
  standalone: false,
})
export class FileUploadComponent {
  @Input() acceptedTypes: string[] = [];
  @Input() label = '';
  @Input() maxSizeMb = 10;
  @Input() completed = false;
  @Output() fileChange = new EventEmitter<File | undefined>();
  error: string | null = null;
  isDragging = false;
  file: File | null = null;

  constructor(private readonly translate: TranslateService) {}

  get isUploadComplete(): boolean {
    return this.completed || !!this.file;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    this.setFile(file);
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
    const file = event.dataTransfer?.files?.[0];
    this.setFile(file);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(): void {
    this.isDragging = false;
  }

  clearUpload(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.error = null;
    this.file = null;
    this.fileChange.emit(undefined);
  }

  private setFile(file: File | undefined): void {
    this.error = null;
    if (!file) {
      this.file = null;
      this.fileChange.emit(undefined);
      return;
    }

    if (!this.acceptedTypes.includes(file.type)) {
      this.error = this.translate.instant(
        'features.fileUpload.errors.invalidType',
      );
      this.file = null;
      this.fileChange.emit(undefined);
      return;
    }

    if (file.size > this.maxSizeMb * 1024 * 1024) {
      this.error = this.translate.instant(
        'features.fileUpload.errors.maxSizeExceeded',
      );
      return;
    }

    this.file = file;
    this.fileChange.emit(file);
  }
}
